export const MASKED_SNN = '*****';
